import React from "react";
var __jsx = React.createElement;
import Column from './Column';
function LayoutFullText(_ref) {
  var yextInfo = _ref.yextInfo,
    isLoading = _ref.isLoading;
  return __jsx(Column, {
    isLoading: isLoading,
    className: "l-col-full",
    yextInfo: yextInfo,
    headlineFieldId: "c_websiteBannerExpandedFirstColumnHeadline",
    textFieldId: "c_websiteBannerExpandedFirstColumnText"
  });
}
export default LayoutFullText;